<template>
  <div class="footer-bank">
    <div class="footer-bank__list">
      <img
        src="/img/footer/verification/kycaid.svg"
        alt="kycaid"
        class="footer-bank__image"
      />
    </div>
    <UiText
      font="body-heading-5"
      color="neutral-500"
    >
      {{ $t('footer.verifText1') }}<br /><span class="footer-bank__white-text">{{ $t('footer.verifText2') }}</span>
    </UiText>
  </div>
</template>

<script>
export default {
  name: 'FooterBank',
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
